<template>
    <div class="ur-data-grid__edit__element ur-data-grid__edit__date-picker">
        <!-- [AREA] picker area -->
        <mask-field ref="anchor"
                :placeholder="$format" :disabled="disabled" 
                :pattern="mask"
                :value="currText" @input="onInput"
                @blur="onBlur" @focus="onFocus"
                @click="clickInput"
                @mousedown.stop="close"
                v-on="{...$listeners, input:()=>{}}"/>
        <ur-icon-button class="ur-data-grid__edit__element__icon
                               ur-data-grid__edit__date-picker__icon"
                 @click="clickInput" icon="calendar" tabindex="-1"/>
        <!-- [AREA] picker area END -->
        
        <!-- [AREA] Calendar area -->
        <picker-calendar ref="picker" v-if="showFlag"
                :anchor="$refs.anchor" :attach-root="attachRoot"
                :value="currVal" @input="pickerInput"
                v-click-outside.anchor="onClickOutside"
                :min-date="minDate" :max-date="maxDate" :format="dateFormat"
                :msg-today="msgToday" :msg-confirm="msgConfirm"/>
        <!-- [AREA] Calendar area END -->
    </div>
</template>

<script>
import maskField      from "./urDataGridEditMaskField";
import pickerCalendar from "./sub/urDataGridEditDatePickerCalendar"
import clickOutside from '../common/direc/urDataGridClickOutside.js'
import {dateToText, textToDate} from "../util"

export default {
    name: 'urDataGridEditDatePicker',
    components : {maskField, pickerCalendar},
    props: {
        value      : {type: [String, Date, Number, Object, Array]},
        dateFormat : {type: String, default: 'YYYY-MM-DD'},
        timezone   : {type: [Number]},
        returnType : {type: String, default: 'date'},  // 'date' | 'string'
        minDate    : {type: [String, Date]},
        maxDate    : {type: [String, Date]},
        disabled   : {type: Boolean, default: false},
        // ---------------
        attachRoot : {type:Boolean, default: false},
        // ---------------
        msgToday   : String,
        msgConfirm : String
    },
    data() {return {
        currVal : null,
        currText : '',
        showFlag : false
    }},
    computed: {
        mask()     { return this.$format.replace(/[YMD]/gi,'#') },
        $format()  { return this.dateFormat.toUpperCase(); },// is not reactive? (leading $)
        $timezone(){return typeof this.timezone === 'number' ? this.timezone : null}
    },
    watch: {
        // -ㄴ- Watch is too heavy
        value : {immediate:true, handler(val, old) { // Value from parent!
            // >> value -> currVal -> currText -> maskField
            // 1. typed process
            switch(this.returnType) {
            case 'long':
            case 'date':
                // 1.1 case Date
                if(!val) {
                    this.currVal = null;
                } else if(val instanceof Date) {
                    this.currVal = val;
                } else if (Array.isArray(val) && val.length === 0) {
					this.currVal = null;
                } else if (Array.isArray(val) && val.length > 0) {
					//console.log("val[0]", val[0]);
					if(val[0] instanceof Date) {
						this.currVal = val[0];
					}
					else if((typeof val[0] === 'string' || val[0] instanceof String) && val[0].startsWith("Invalid Date")) {
						//console.log("invalid date");
						this.currVal = null;
					}
					else {
						this.currVal = val[0];
					}
				}
				else if(typeof val === 'number') {
                    this.currVal = new Date(val);
                } else {
                    console.warn('[UIDev] Date picker expect date type value, but the input is not a Date object')
                    this.currVal = textToDate(val, this.$format);
                }
                break;
            case 'string':
                // 1.1 case String
                if(!val) {
                    this.currVal = null;
                } else if(typeof val === 'string') {
                    this.currVal = textToDate(val, this.$format);
                } else {
                    // 이건 무슨 상황일까? Date 개꿀?
                    console.warn('[UIDev] Date picker expect string type value, but the input is not a String')
                    this.currVal = new Date(val);
                }
                break;
            }
            // 2. isValidDate -> conv to Text
            this.currText = dateToText(this.currVal, this.$format);
        }},
    },
    methods: {
        onFocus() {this.$emit('focus')},
        onBlur()  {this.$emit('blur')},
        // [METHOD] Event & Actions
        onClickOutside(e) {
            this.closeCal()
        },
        clickInput() {
            if(this.disabled) return;
            //this.openCal(); // 두고보자
            this.toggleShowFlag(); // ㅇㅇ 아냐
        },
        pickerInput(v) {
            // 1. set myself
            this.currVal = v;
            // 2. emit fire
            this.emitValue(v);
            this.emitValue(v, 'picker:confirm')
            // 3. set text
            this.currText = dateToText(v,this.$format);
            // 4. close modal
            this.closeCal();
            this.$refs.anchor.focus();
        },
        onInput(v) {
            // >> maskField -> currText -> currVal -> value
            //                 currText <- currVal <-
            // 1. set to currText
            this.currText = v;
            // 2. convert to date
            var date = textToDate(v, this.$format);
            if(v && !date) {return;}
            // 3. emit to parent
            this.currVal = date;
            this.emitValue(date);
        },
        emitValue(date, event) {
            var $evt = event || 'input'
            var dt = date;
            if(typeof this.$timezone === 'number') {
                const OF = date.getTimezoneOffset();
                const TZ = this.$timezone * -1 * 60;
                dt = new Date(date.getTime() + (TZ-OF)*60*1000);
            }
            switch(this.returnType) {
            case 'date':
                this.$emit($evt,dt);
                break;
            case 'long':
                this.$emit($evt,date?dt.getTime():null);
                break;
            case 'string':
                this.$emit($evt,dateToText(dt,this.$format));
                break;
            }
        },
        // [METHOD] Logics.
        
        
        // [METHOD] Functions.
        closeCal() {this.toggleShowFlag(false)},
        openCal()  {this.toggleShowFlag(true)},
        toggleShowFlag(flag) {
            if(typeof flag==='boolean') {this.showFlag = flag}
            else {this.showFlag = !this.showFlag}
            this.$emit('on-flotage',this.showFlag);
        },
        focus(opts) {
            this.$refs.anchor.focus(opts);
        },
        selectAll() {
            this.$refs.anchor.selectAll();
        },

        // [METHOD] custom.
        close() {
            if(this.$parent.$options._componentTag != 'header-context') {
                this.$parent.gridInfo.func.setHeaderContext(null);
            }
        }, 

    },
    directives: {'click-outside': clickOutside,}
}
</script>
